<template>
    <v-container>

        <!-- HEADER -->
        <v-row class="mt-5" align="center">
            <v-col cols="12">
                <div class="title-section">
                    Notificaciones
                </div>
            </v-col>
            <v-col cols="4">
                <v-icon color="black" large>mdi-bell-ring</v-icon>
                <b>Notificaciones creadas</b>
            </v-col>
            <v-col cols="4">
                <v-btn v-if="isAdmin || isAmbUser" class="normal-btn" color="primary" depressed
                    @click="showCreateDialog">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    Crear Notificación
                </v-btn>
            </v-col>
            <v-col cols="4">
                <kimsa-text-field placeholder="Buscar" append-icon="mdi-magnify" outlined dense solo flat
                    @change="search = $event" />
            </v-col>
        </v-row>

        <!-- TABLE -->
        <v-data-table class="mt-5" :headers="headers" :loading="loading" :items="notifications" :search.sync="search"
            :items-per-page="5">
            <template v-slot:item.actions="{ item }">
                <v-btn class="mr-1 my-1" fab outlined x-small @click.stop="editItem(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="isAdmin" class="mr-1 my-1" fab outlined x-small @click.stop="deleteItem(item)">
                    <v-icon color="primary">mdi-delete</v-icon>
                </v-btn>
                <v-btn class="mr-1 my-1" fab outlined x-small @click.stop="pdfItem(item)" :loading="item.loadingPdf">
                    <v-icon>mdi-download</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- COMPONENTS -->
        <create-notification-dialog @success="loadNotifications" ref="creator" />

        <kimsa-confirm title="Eliminar" content="¿Esta seguro que desea eliminar esta notificación?" persistent
            @confirm="onConfirmDelete" @cancel="currentId = null" :loading="loadingDelete" no-close-on-confirm
            ref="confirm" />

    </v-container>
</template>

<script>
import Axios from "@/utils/Axios";
import KimsaConfirm from "@/components/common/KimsaConfirm";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import CreateNotificationDialog from '../../components/notitications/CreateNotificationDialog.vue';

export default {
    name: "Notifications",
    components: { KimsaTextField, KimsaConfirm, CreateNotificationDialog },
    data() {
        return {
            loading: false,
            notifications: [],
            search: '',
            currentId: null,
            loadingDelete: false,
            headers: [
                { text: 'Cliente', value: 'client', class: 'grey white--text' },
                { text: 'Fecha', value: 'date', class: 'grey white--text' },
                { text: 'Código', value: 'code', class: 'grey white--text' },
                { text: 'Asunto', value: 'name', class: 'grey white--text' },
                { text: 'Tipo', value: 'type', class: 'grey white--text' },
                { text: '', value: 'actions', sortable: false, class: 'grey' },
            ],
        }
    },
    async mounted() {
        const vm = this
        await vm.loadNotifications()
    },
    methods: {
        async loadNotifications() {
            const vm = this
            vm.loading = true

            await Axios.post('notifications').then(res => {
                // console.log('res loadNotifications', res)
                vm.notifications = res.data.result.notifications.map(notification => {
                    return {
                        id: notification.id,
                        name: notification.name,
                        addressed: notification.addressed,
                        code: notification.code,
                        notificationId: notification.notification_type_id,
                        type: notification.type.name,
                        client: notification.client.name,
                        clientId: notification.client_id,
                        userId: notification.user_id,
                        date: notification.date,
                        records: notification.records,
                        notes: notification.notes,
                        created_at: vm.$moment(notification.created_at).format('DD-MM-YYYY'),
                        updated_at: vm.$moment(notification.updated_at).format('DD-MM-YYYY'),
                        loadingPdf: false,
                    }
                })
                // console.log('vm.notifications', vm.notifications)
            }).catch(er => {
                console.log('error loadNotifications', er)
            }).finally(() => {
                vm.loading = false
            })
        },
        showCreateDialog() {
            const vm = this
            vm.$refs.creator.show()
        },
        editItem(item) {
            const vm = this
            vm.$refs.creator.loadNotification(item)
        },
        deleteItem(item) {
            const vm = this
            vm.$refs.confirm.show()
            vm.currentId = item.id
        },
        async onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true

            await Axios.delete(`notifications/${vm.currentId}/delete`).then(res => {
                // console.log('res onConfirmDelete',res)
                vm.toast('Notificación eliminada')
            }).catch(er => {
                console.log('er', er)
                vm.toast('error onConfirmDelete', er)
            })

            vm.loadingDelete = false
            vm.currentId = null

            vm.$refs.confirm.hide()
            await vm.loadNotifications()
        },
        async pdfItem(item) {
            const vm = this
            item.loadingPdf = true

            let url = `notifications/${item.id}/pdf`

            await Axios.get(url).then(res => {
                console.log('res pdfItem', res)
                const pdf = res.data.result.pdf
                const linkSource = `data:application/pdf;base64,${pdf}`;
                const downloadLink = document.createElement("a");
                const fileName = `${item.code}.pdf`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }).catch(er => {
                console.log('er', er)
                vm.toast(`error downloadPDF: ${er}`, 'error')
            }).finally(() => {
                item.loadingPdf = false
            })
        },
    }
}
</script>

<style scoped>
.title-section {
    color: var(--v-primary-base);
}
</style>